<template>
	<div class="helpdeskstaff">
		<div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<card>
		
		<div>
			<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Добавить сотрудника" />
		</div>
		<div>
			<el-table :data="ApiData" style="width: 100%;">
				<el-table-column
					label="ID"
					property="id"
					width="80"
					sortable
			>
			</el-table-column>
			<el-table-column 
					min-width="180"
					label="ФИО"
					property="agent_name"
					sortable
			>
			</el-table-column>
			
			<el-table-column
					width="160"
					label="Действие"
					align="right"                    	
			>
					<template v-slot="scope">			
							<el-tooltip content="Удалить" placement="top">
								<el-button class="no-border my-0">
									<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DeleteRow(scope.row)">
										<i class="tim-icons icon-trash-simple"></i>
									</button>											
								</el-button>
							</el-tooltip>		
					</template>
			</el-table-column>
			
			</el-table>
		</div>
	</card>
	</div>
</template>
<script>

// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
// import Pagination from 'src/our_components/RePagination';

export default {
	name: 'helpdeskstaff-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// ReFilterBtn,
        // ReFilter,
        ReFormPrinter,
        // Pagination,
	},
	data() {
		return {
			ApiData: [],
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			objGetParams:{},
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('HELPDESK_STAFF.GET',{flt:{'list':'true',helpdesk_id:this.$route.params.hd_id}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		currentFormConfig() {
			this.$GVO.ApiCall('HELPDESK_STAFF.GET_FORM_MODEL',{flt:{helpdesk_id:this.$route.params.hd_id}})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
            return {apiMethod:'HELPDESK_STAFF.INS',apiParam:{iData:[]}};
        },
		SuccessGo(evt,dopParam){
	        this.masAllFormParams = this.currentFormConfig();
			this.getApiData();
		},
		DeleteRow(row){
			if(row.id != null){
				this.$GVO.ApiCall('HELPDESK_STAFF.DEL',{ flt:{id: row.id,helpdesk_id:this.$route.params.hd_id}}) 
					.then((objApi) => {
						if(objApi.success === true){
							this.getApiData();
						}else{
							alert('Не удалилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		},
		GoBack(){
			this.$router.back();
		},
	},		
	mounted() {
		this.getApiData();
	}
};
</script>
<style scoped>
.helpdeskstaff .bntGroup{
		position: absolute;
		z-index: 1;
		right: 40px;
	}
</style>
